


























































































import { Component, Vue } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters({
            unit: 'StaffProperties/getStaffCurrentProperty',
        }),
    },
})
export default class UserUnitsDetails extends Vue {
    constructor() {
        super();
    }

    get selectedUnit() {
        return this.$store.getters['StaffProperties/getStaffCurrentProperty'];
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, '');
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffBackButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
    }

    public mounted() {
        if (!this.selectedUnit) {
            this.$store.dispatch(Actions.FETCH_STAFF_PROPERTY, this.$store.getters['StaffProperties/getStaffPropertyIconLink']);
        }
    }

    public destroyed() {
        this.$store.commit(Mutations.SET_STAFF_CURRENT_PROPERTY, null);
    }
}
